import React from 'react';
import $ from 'jquery';
import 'jquery.easing';
import 'animate.css';
import { FaChevronUp } from "react-icons/fa";

class BackToTop extends React.Component {
    componentDidMount() {
        $('.back-to-top').click(function () {
            $('html, body').animate({ scrollTop: 0 }, 600, 'easeInOutExpo');
            return false;
        });
        window.addEventListener('scroll', () => {
            const backToTopElement = document.querySelector('.back-to-top') as HTMLElement;
            if (backToTopElement) {
                if (window.pageYOffset > 100) {
                    backToTopElement.classList.remove('fadeOut');
                    backToTopElement.style.display = 'block';
                    backToTopElement.classList.add('fadeIn');
                } else {
                    backToTopElement.classList.remove('fadeIn');
                    backToTopElement.classList.add('fadeOut');
                }
            }
        });
    }

    render() {
        return (
            <a href="#" className="back-to-top animated">
                <FaChevronUp size={20}  className="back-to-top-icon"/>
            </a>
        );

    }
}

export default BackToTop;